import { createContext, useContext } from 'react';

// Find state for the in-text mark. Context rather than props, so the memoised
// node/card components keep their prop shapes.
export type FindHighlight = {
  // Lower-cased and trimmed; '' when search is closed.
  query: string;
  currentNodeId: string | null;
  matchedNodeIds: ReadonlySet<string>;
  // See TiptapHighlight.
  currentRun: number;
};

const EMPTY: FindHighlight = {
  query: '',
  currentNodeId: null,
  matchedNodeIds: new Set(),
  currentRun: -1,
};

const FindHighlightContext = createContext<FindHighlight>(EMPTY);

export const FindHighlightProvider = FindHighlightContext.Provider;

export function useFindHighlight(): FindHighlight {
  return useContext(FindHighlightContext);
}
